var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('card-list',{attrs:{"data-headers":_vm.tHeaders,"title":"Supplier List","data-size":"10","data-url":"/api/v1/supplier","edit-route":"/master/supplier/add","delete-endpoint":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }